/**
 * Preserve existing SEO enrichment alongside the source design. This does not
 * author new FAQ answers, copy inventory prices into prose, or change routes.
 * @param {{internalLinks?: Array<{href: string, label: string, section?: string}>, faqs?: Array<{q: string, a: string}>} | null | undefined} enrichment
 * @param {Array<{q: string, a: string}> | null | undefined} authoredFaqs
 */
export function selectMustangSeoSupplement(enrichment, authoredFaqs) {
  const faqs = (Array.isArray(authoredFaqs) ? authoredFaqs : Array.isArray(enrichment?.faqs) ? enrichment.faqs : [])
    .filter((faq) => typeof faq?.q === "string" && faq.q.trim() &&
      typeof faq?.a === "string" && faq.a.trim());
  const seen = new Set();
  const internalLinks = (Array.isArray(enrichment?.internalLinks) ? enrichment.internalLinks : []).filter((link) => {
    if (!link || typeof link.href !== "string" || typeof link.label !== "string" ||
      !link.label.trim() || !/^\/(?!\/)/.test(link.href) || /[\\\s<>"\u0000-\u001f]/.test(link.href) ||
      ["/rentafordmustang", "/lp/rentafordmustang"].includes(link.href.replace(/\/$/, "")) ||
      /^call to list\b/i.test(link.label.trim()) || seen.has(link.href)) return false;
    seen.add(link.href);
    return true;
  }).map((link) => ({
    href: link.href,
    label: link.href === "/" && link.label === "homepage" ? "DriveShare home" :
      link.href === "/about" && link.label === "about" ? "About DriveShare" : link.label,
    section: link.section || "Related rental pages",
  }));
  return { faqs, internalLinks };
}

/** The FAQ schema and visible answers always come from the same set. */
export function mustangFaqSchema(faqs) {
  return faqs.length ? {
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question", name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  } : null;
}